import { render, staticRenderFns } from "./calc-banks.vue?vue&type=template&id=6c5679ae&scoped=true"
import script from "./calc-banks.vue?vue&type=script&lang=ts"
export * from "./calc-banks.vue?vue&type=script&lang=ts"
import style0 from "./calc-banks.vue?vue&type=style&index=0&id=6c5679ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5679ae",
  null
  
)

export default component.exports